import { assign } from 'fsm';
import { LOADING_DELAY, COMPLETION_DELAY } from './constants';
export const refreshProgressMachine = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        START_REFRESHING: {
          target: 'delaying'
        }
      },
      tags: ['hidden']
    },
    delaying: {
      invoke: {
        src: 'delayService',
        onDone: {
          target: 'animating',
          actions: ['resetProgress']
        }
      },
      on: {
        STOP_REFRESHING: 'idle'
      },
      tags: ['hidden']
    },
    animating: {
      on: {
        UPDATE_PROGRESS: {
          actions: ['updateProgress']
        },
        STOP_REFRESHING: {
          target: 'completing',
          actions: ['setProgressToComplete']
        }
      },
      tags: ['visible']
    },
    completing: {
      invoke: {
        src: 'completionDelayService',
        onDone: 'idle'
      },
      tags: ['visible']
    }
  },
  actions: {
    resetProgress: assign(() => ({
      progressValue: 0
    })),
    updateProgress: assign((context, event) => ({
      progressValue: event.type === 'UPDATE_PROGRESS' ? event.value : context.progressValue
    })),
    setProgressToComplete: assign(() => ({
      progressValue: 100
    }))
  },
  guards: {},
  services: {
    delayService: () => new Promise(resolve => setTimeout(resolve, LOADING_DELAY)),
    completionDelayService: () => new Promise(resolve => setTimeout(resolve, COMPLETION_DELAY))
  }
};